import { render, staticRenderFns } from "./materialInventoryModal.vue?vue&type=template&id=f74dba98&scoped=true&"
import script from "./materialInventoryModal.vue?vue&type=script&lang=js&"
export * from "./materialInventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./materialInventoryModal.vue?vue&type=style&index=0&id=f74dba98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74dba98",
  null
  
)

export default component.exports